module.exports = __webpack_public_path__ + "static/media/na.bb49a403.svg";